<template>
  <div>
    <!-- 积分概览卡片 -->
    <div class="row mb-3">
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-3">
        <div class="card">
          <div class="card-body p-3">
            <div class="d-flex align-items-center">
              <div class="bg-gradient-success icon-shape rounded-circle me-3" style="width:48px;height:48px;display:flex;align-items:center;justify-content:center;">
                <i class="ni ni-money-coins text-white" style="font-size:1.2rem;"></i>
              </div>
              <div>
                <p class="text-xs text-secondary mb-0">充值总额</p>
                <h6 class="mb-0">{{ formatPoints(overview.total_recharge) }} <span class="text-xs text-muted">积分</span></h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-3">
        <div class="card">
          <div class="card-body p-3">
            <div class="d-flex align-items-center">
              <div class="bg-gradient-danger icon-shape rounded-circle me-3" style="width:48px;height:48px;display:flex;align-items:center;justify-content:center;">
                <i class="ni ni-fat-rm text-white" style="font-size:1.2rem;"></i>
              </div>
              <div>
                <p class="text-xs text-secondary mb-0">消耗总额</p>
                <h6 class="mb-0">{{ formatPoints(overview.total_consume) }} <span class="text-xs text-muted">积分</span></h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-3">
        <div class="card">
          <div class="card-body p-3">
            <div class="d-flex align-items-center">
              <div class="bg-gradient-info icon-shape rounded-circle me-3" style="width:48px;height:48px;display:flex;align-items:center;justify-content:center;">
                <i class="ni ni-credit-card text-white" style="font-size:1.2rem;"></i>
              </div>
              <div>
                <p class="text-xs text-secondary mb-0">当前余额</p>
                <h6 class="mb-0">{{ formatPoints(overview.total_balance) }} <span class="text-xs text-muted">积分</span></h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-3">
        <div class="card">
          <div class="card-body p-3">
            <div class="d-flex align-items-center">
              <div class="icon-shape rounded-circle me-3" :class="overview.balanced ? 'bg-gradient-success' : 'bg-gradient-warning'" style="width:48px;height:48px;display:flex;align-items:center;justify-content:center;">
                <i class="ni ni-check-bold text-white" style="font-size:1.2rem;" v-if="overview.balanced"></i>
                <i class="ni ni-alert-circle text-white" style="font-size:1.2rem;" v-else></i>
              </div>
              <div>
                <p class="text-xs text-secondary mb-0">账目配平</p>
                <h6 class="mb-0">
                  <span :class="overview.balanced ? 'text-success' : 'text-warning'">{{ overview.balanced ? '已配平' : '未配平' }}</span>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 提示信息 -->
    <div class="card">
      <div class="card-body p-4">
        <div v-if="loading" class="text-center text-secondary text-xs py-4">加载中...</div>
        <div v-else-if="error" class="text-center text-danger text-xs py-4">{{ error }}</div>
        <div v-else-if="overview.total_recharge === 0 && overview.total_consume === 0" class="text-center text-secondary text-xs py-4">
          选定时间段内暂无积分数据
        </div>
        <div v-else>
          <!-- 子 Tab 导航 -->
          <ul class="nav nav-pills nav-fill mb-3">
            <li class="nav-item">
              <button class="nav-link nav-link-sm" :class="{ active: subTab === 'overview' }" @click="subTab = 'overview'">
                概览明细
              </button>
            </li>
            <li class="nav-item">
              <button class="nav-link nav-link-sm" :class="{ active: subTab === 'recharge' }" @click="switchSubTab('recharge')">
                充值记录 ({{ rechargeTotal }})
              </button>
            </li>
            <li class="nav-item">
              <button class="nav-link nav-link-sm" :class="{ active: subTab === 'consume' }" @click="switchSubTab('consume')">
                消耗记录 ({{ consumeTotal }})
              </button>
            </li>
          </ul>

          <!-- 概览明细 -->
          <div v-show="subTab === 'overview'">
            <div class="table-responsive">
              <table class="table table-sm table-bordered align-middle">
                <thead class="table-light">
                  <tr><th colspan="4" class="text-center text-xs">周期内积分变动概览</th></tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-xs text-secondary">期初余额</td>
                    <td class="text-sm">{{ formatPoints(overview.opening_balance) }}</td>
                    <td class="text-xs text-secondary">周期净变动</td>
                    <td class="text-sm">{{ formatPoints(overview.period_net_change) }}</td>
                  </tr>
                  <tr>
                    <td class="text-xs text-secondary">期望期末余额</td>
                    <td class="text-sm">{{ formatPoints(overview.expected_closing) }}</td>
                    <td class="text-xs text-secondary">实际期末余额</td>
                    <td class="text-sm">{{ formatPoints(overview.total_balance) }}</td>
                  </tr>
                  <tr>
                    <td class="text-xs text-secondary">直购消耗</td>
                    <td class="text-sm">{{ formatPoints(overview.consume_direct) }} <span class="text-xs text-muted">({{ overview.consume_direct_count }}笔)</span></td>
                    <td class="text-xs text-secondary">挑战消耗</td>
                    <td class="text-sm">{{ formatPoints(overview.consume_challenge) }} <span class="text-xs text-muted">({{ overview.consume_challenge_count }}笔)</span></td>
                  </tr>
                  <tr>
                    <td class="text-xs text-secondary">周期退分</td>
                    <td class="text-sm">{{ formatPoints(overview.period_refund) }}</td>
                    <td class="text-xs text-secondary">周期赠送</td>
                    <td class="text-sm">{{ formatPoints(overview.period_grant) }}</td>
                  </tr>
                  <tr>
                    <td class="text-xs text-secondary">调额增加</td>
                    <td class="text-sm">{{ formatPoints(overview.period_adjust_increase) }}</td>
                    <td class="text-xs text-secondary">调额减少</td>
                    <td class="text-sm">{{ formatPoints(overview.period_adjust_decrease) }}</td>
                  </tr>
                  <tr>
                    <td class="text-xs text-secondary">累计调额增加</td>
                    <td class="text-sm">{{ formatPoints(overview.total_adjust_increase) }}</td>
                    <td class="text-xs text-secondary">累计调额减少</td>
                    <td class="text-sm">{{ formatPoints(overview.total_adjust_decrease) }}</td>
                  </tr>
                  <tr>
                    <td class="text-xs text-secondary">是否有清零点</td>
                    <td class="text-sm">{{ overview.has_clean_point ? '是' : '否' }}</td>
                    <td class="text-xs text-secondary">账目配平</td>
                    <td class="text-sm">
                      <span :class="overview.balanced ? 'text-success' : 'text-warning'">{{ overview.balanced ? '✓ 已配平' : '✗ 未配平' }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- 充值记录 -->
          <div v-show="subTab === 'recharge'">
            <div v-if="rechargeLoading" class="text-center text-secondary text-xs py-4">加载中...</div>
            <div v-else-if="rechargeList.length === 0" class="text-center text-secondary text-xs py-4">暂无充值记录</div>
            <div v-else>
              <p class="text-xs text-secondary mb-2">共 {{ rechargeTotal }} 条记录，总积分 {{ formatPoints(rechargeTotalAmount) }}</p>
              <div class="table-responsive" style="max-height:500px;overflow-y:auto;">
                <table class="table table-sm table-hover align-middle">
                  <thead class="table-light sticky-top">
                    <tr>
                      <th class="text-xs">时间</th>
                      <th class="text-xs">客户ID</th>
                      <th class="text-xs">手机号</th>
                      <th class="text-xs">商户号</th>
                      <th class="text-xs">商户名称</th>
                      <th class="text-xs text-end">积分变动</th>
                      <th class="text-xs">变动后余额</th>
                      <th class="text-xs">业务类型</th>
                      <th class="text-xs">备注</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in rechargeList" :key="item.id">
                      <td class="text-xs">{{ formatTime(item.created_at) }}</td>
                      <td class="text-xs">{{ item.customer_id }}</td>
                      <td class="text-xs">{{ maskPhone(item.phone) }}</td>
                      <td class="text-xs">{{ item.deliver_id || '-' }}</td>
                      <td class="text-xs">{{ merchantDisplayName(item) }}</td>
                      <td class="text-xs text-end text-success">+{{ formatPoints(item.amount) }}</td>
                      <td class="text-xs">{{ formatPoints(item.balance_after) }}</td>
                      <td class="text-xs">{{ bizTypeName(item.biz_type) }}</td>
                      <td class="text-xs text-muted">{{ item.remark || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- 消耗记录 -->
          <div v-show="subTab === 'consume'">
            <div v-if="consumeLoading" class="text-center text-secondary text-xs py-4">加载中...</div>
            <div v-else-if="consumeList.length === 0" class="text-center text-secondary text-xs py-4">暂无消耗记录</div>
            <div v-else>
              <p class="text-xs text-secondary mb-2">共 {{ consumeTotal }} 条记录，总积分 {{ formatPoints(consumeTotalAmount) }}</p>
              <div class="table-responsive" style="max-height:500px;overflow-y:auto;">
                <table class="table table-sm table-hover align-middle">
                  <thead class="table-light sticky-top">
                    <tr>
                      <th class="text-xs">时间</th>
                      <th class="text-xs">客户ID</th>
                      <th class="text-xs">设备</th>
                      <th class="text-xs text-end">积分变动</th>
                      <th class="text-xs">变动后余额</th>
                      <th class="text-xs">业务类型</th>
                      <th class="text-xs">备注</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in consumeList" :key="item.id">
                      <td class="text-xs">{{ formatTime(item.created_at) }}</td>
                      <td class="text-xs">{{ item.customer_id }}</td>
                      <td class="text-xs">{{ item.board_id || '-' }}</td>
                      <td class="text-xs text-end text-danger">{{ formatPoints(item.amount) }}</td>
                      <td class="text-xs">{{ formatPoints(item.balance_after) }}</td>
                      <td class="text-xs">{{ bizTypeName(item.biz_type) }}</td>
                      <td class="text-xs text-muted">{{ item.remark || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPointsReport, getPointsRechargeRecords, getPointsConsumeRecords } from "@/api/dashboard";
import { getMerchantInfoMap } from "@/utils/merchantCache";

export default {
  name: "PointsReport",
  props: {
    deliverId: { type: Number, default: 0 },
    startDate: { type: Number, required: true },
    endDate: { type: Number, required: true },
  },
  data() {
    return {
      overview: {
        total_recharge: 0,
        total_consume: 0,
        total_balance: 0,
        opening_balance: 0,
        period_net_change: 0,
        expected_closing: 0,
        consume_direct: 0,
        consume_direct_count: 0,
        consume_challenge: 0,
        consume_challenge_count: 0,
        period_refund: 0,
        period_grant: 0,
        period_adjust_increase: 0,
        period_adjust_decrease: 0,
        total_adjust_increase: 0,
        total_adjust_decrease: 0,
        has_clean_point: false,
        balanced: false,
      },
      loading: false,
      error: "",
      subTab: "overview",
      rechargeList: [],
      rechargeTotal: 0,
      rechargeTotalAmount: 0,
      rechargeLoaded: false,
      rechargeLoading: false,
      consumeList: [],
      consumeTotal: 0,
      consumeTotalAmount: 0,
      consumeLoaded: false,
      consumeLoading: false,
      merchantInfoMap: {},
    };
  },
  watch: {
    deliverId() { this.resetAndFetch(); },
    startDate() { this.resetAndFetch(); },
    endDate() { this.resetAndFetch(); },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    formatPoints(val) {
      if (!val) return "0";
      return String(val);
    },
    formatTime(ts) {
      if (!ts) return "-";
      const d = new Date(ts * 1000);
      return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")} ${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}`;
    },
    bizTypeName(t) {
      const map = { arcade: "设备", dining: "餐饮", retail: "零售" };
      return map[t] || t || "-";
    },
    maskPhone(phone) {
      if (!phone || phone.length < 7) return phone || '-';
      return phone.substring(0, 3) + '****' + phone.substring(phone.length - 4);
    },
    merchantDisplayName(item) {
      if (!item.deliver_id) return '-';
      const info = this.merchantInfoMap[item.deliver_id] || {};
      return info.account_holder || item.deliver_nick_name || info.nick_name || item.deliver_name || info.name || ('商家' + item.deliver_id);
    },
    buildParams() {
      const params = { start_date: this.startDate, end_date: this.endDate };
      if (this.deliverId > 0) params.deliver_id = this.deliverId;
      return params;
    },
    resetAndFetch() {
      this.rechargeLoaded = false;
      this.consumeLoaded = false;
      this.rechargeList = [];
      this.consumeList = [];
      this.rechargeTotal = 0;
      this.consumeTotal = 0;
      this.fetchData();
    },
    switchSubTab(tab) {
      this.subTab = tab;
      if (tab === "recharge" && !this.rechargeLoaded) this.fetchRecharge();
      if (tab === "consume" && !this.consumeLoaded) this.fetchConsume();
    },
    async fetchData() {
      this.loading = true;
      this.error = "";
      try {
        const resp = await getPointsReport(this.buildParams());
        if (resp.code === 0 && resp.desc) {
          this.overview = { ...this.overview, ...resp.desc };
        } else if (resp.code !== 0) {
          this.error = resp.desc || "查询失败";
        }
      } catch (err) {
        console.error("获取积分报表失败:", err);
        this.error = "请求失败";
      } finally {
        this.loading = false;
      }
    },
    async fetchRecharge() {
      this.rechargeLoading = true;
      try {
        if (Object.keys(this.merchantInfoMap).length === 0) {
          this.merchantInfoMap = await getMerchantInfoMap();
        }
        const resp = await getPointsRechargeRecords({
          ...this.buildParams(),
          page: 1,
          page_size: 100,
        });
        if (resp.code === 0 && resp.desc) {
          this.rechargeList = resp.desc.list || [];
          this.rechargeTotal = resp.desc.total || this.rechargeList.length;
          this.rechargeTotalAmount = resp.desc.total_amount || 0;
          this.rechargeLoaded = true;
        }
      } catch (err) {
        console.error("获取充值记录失败:", err);
      } finally {
        this.rechargeLoading = false;
      }
    },
    async fetchConsume() {
      this.consumeLoading = true;
      try {
        const resp = await getPointsConsumeRecords({
          ...this.buildParams(),
          page: 1,
          page_size: 100,
        });
        if (resp.code === 0 && resp.desc) {
          this.consumeList = resp.desc.list || [];
          this.consumeTotal = resp.desc.total || this.consumeList.length;
          this.consumeTotalAmount = resp.desc.total_amount || 0;
          this.consumeLoaded = true;
        }
      } catch (err) {
        console.error("获取消耗记录失败:", err);
      } finally {
        this.consumeLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.nav-link-sm {
  font-size: 0.8rem;
  padding: 0.25rem 0.75rem;
}
.nav-pills .nav-link {
  color: #6c757d;
  border: 1px solid transparent;
  transition: all 0.2s ease;
}
.nav-pills .nav-link:hover {
  color: #344767;
  background-color: rgba(52, 71, 103, 0.08);
}
.nav-pills .nav-link.active {
  color: #fff;
  background-color: #344767;
  border-color: #344767;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(52, 71, 103, 0.2);
}
</style>
